module.exports = __webpack_public_path__ + "files/7aadbe308c9387e45e16f8bb8106bad7.png";